// extracted by mini-css-extract-plugin
module.exports = {"closeSection":"occupancy_settings_form_closeSection__3TeRR"};